import React from 'react'
import Grid from "@mui/material/Grid";
import {TextField} from "@material-ui/core";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from '@mui/icons-material/Add';

const TradeRow = ({register, nameKey, index, onAddTrade, onDeleteTrade, errors}) => {
  const shrinkProp = {shrink: true};
  const getNested = (theObject, path, separator) => {
    try {
      separator = separator || '.';

      return path.replace('[', separator).replace(']', '').split(separator).reduce(
        function (obj, property) {
          return obj[property];
        }, theObject
      );

    } catch (err) {
      return undefined;
    }
  }

  return (
    <Grid container spacing={{xs: 2, sm: 1, md: 1}}>
      <Grid item sx={{display: 'none'}}>
        <TextField hidden={true} label="Trade Id" {...register(`${nameKey}.tradeId`, {required: false})}/>
      </Grid>
      <Grid item xs={8} md={2}>
        <TextField label="Symbol" variant="outlined" size="small" placeholder="NSE" InputLabelProps={shrinkProp}
                   error={errors && !!getNested(errors, nameKey)?.['symbol']}
                   helperText={errors && getNested(errors, nameKey)?.['symbol']?.message}
                   {...register(`${nameKey}.symbol`, {required: true})}/>
      </Grid>
      <Grid item xs={4} sx={{display: {xs: 'block', md: 'none'}}} textAlign="right">
        {index !== 0 && <DeleteIcon onClick={onDeleteTrade}/>}
        <AddIcon onClick={onAddTrade}/>
      </Grid>
      <Grid item xs={6} md={2}>
        <TextField label="Bought On" variant="outlined" size="small" InputLabelProps={shrinkProp}
                   error={errors && !!getNested(errors, nameKey)?.['buyTs']}
                   helperText={errors && getNested(errors, nameKey)?.['buyTs']?.message}
                   {...register(`${nameKey}.buyTs`, {required: true})}/>
      </Grid>
      <Grid item xs={3} md={1}>
        <TextField label="Buy Price" variant="outlined" size="small" InputLabelProps={shrinkProp}
                   error={errors && !!getNested(errors, nameKey)?.['buyPrice']}
                   helperText={errors && getNested(errors, nameKey)?.['buyPrice']?.message}
                   {...register(`${nameKey}.buyPrice`, {required: true})}/>
      </Grid>
      <Grid item xs={3} md={1}>
        <TextField label="Buy Qty" variant="outlined" size="small" InputLabelProps={shrinkProp}
                   error={errors && !!getNested(errors, nameKey)?.['buyQuantity']}
                   helperText={errors && getNested(errors, nameKey)?.['buyQuantity']?.message}
                   {...register(`${nameKey}.buyQuantity`, {required: true})}/>
      </Grid>
      <Grid item xs={6} md={2}>
        <TextField label="Sold On" variant="outlined" size="small" placeholder="YYYY-MM-DD HH:mm:ss"
                   InputLabelProps={shrinkProp}
                   error={errors && !!getNested(errors, nameKey)?.['sellTs']}
                   helperText={errors && getNested(errors, nameKey)?.['sellTs']?.message}
                   {...register(`${nameKey}.sellTs`, {required: false})}/>
      </Grid>
      <Grid item xs={3} md={1}>
        <TextField label="Sell Price" variant="outlined" size="small" InputLabelProps={shrinkProp}
                   error={errors && !!getNested(errors, nameKey)?.['sellPrice']}
                   helperText={errors && getNested(errors, nameKey)?.['sellPrice']?.message}
                   {...register(`${nameKey}.sellPrice`, {required: false})}/>
      </Grid>
      <Grid item xs={3} md={1}>
        <TextField label="Sell Qty" variant="outlined" size="small"
                   InputLabelProps={shrinkProp}
                   error={errors && !!getNested(errors, nameKey)?.['sellQuantity']}
                   helperText={errors && getNested(errors, nameKey)?.['sellQuantity']?.message}
                   {...register(`${nameKey}.sellQuantity`, {required: false})}/>
      </Grid>
      <Grid item xs={4} md={1} sx={{ display: { xs: 'block' } }} >
      </Grid>
      <Grid item md={1} textAlign="right" sx={{display: {xs: 'none', md: 'block'}}}>
        {index !== 0 && <DeleteIcon onClick={onDeleteTrade}/>}
        <AddIcon onClick={onAddTrade}/>
      </Grid>
    </Grid>
  )
}

export default TradeRow